import { render, staticRenderFns } from "./PopupRiskAnalysis.vue?vue&type=template&id=8dec4c58&scoped=true"
import script from "./PopupRiskAnalysis.vue?vue&type=script&lang=js"
export * from "./PopupRiskAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskAnalysis.vue?vue&type=style&index=0&id=8dec4c58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dec4c58",
  null
  
)

export default component.exports